import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import SingleLayer from "../../components/message/SingleLayer";

const SinglePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Text Page" />


        {/* SingleLayer */}
        <SingleLayer />

      </MasterLayout>
    </>
  );
};

export default SinglePage;
